import { lego } from '@zz-common/lego'
import native from '@zz-common/native-adapter'
// @ts-ignore
import { getPageType } from '@/lib/util.ts'
import VARS from '@/lib/vars'

let globalBackup: any = {}
let pagetype = ''

const initLegoData = (param?) => {
  const type = (param && param.type) || ''
  const backup = (param && param.backup) || {}
  pagetype = type || getPageType()
  globalBackup = backup
}
let plat = null
// 因为可能出现多个埋点请求同时发出，前一个埋点已经确定了 wechat，但是 native.asyncIn回调并没有确定到底是 wa 还是 wechat,
// 而后一个埋点可能会直接认为是 wechat，造成 plat 参数不准确，所以这里进行锁定
let isGetPlating = false
// 用于暂存在得到 plat之前（即锁定解锁之前），第一个埋点请求之后的请求
let legicCacheList = []

function legic(actiontype, backup?, fn?) {
  if (isGetPlating) {
    return legicCacheList.push({ actiontype, backup, fn })
  }
  if (plat) {
    globalBackup.t = VARS.t
    globalBackup.channel = VARS.channel
    globalBackup.plat = plat
    backup = Object.assign({}, globalBackup, backup)
    lego.send({
      actiontype,
      pagetype,
      backup
    })
    if (typeof fn === 'function') {
      fn()
    }
  } else {
    plat = native.in('zz') ? 'zz' : null
    // app客户端
    if (plat) {
      return legic(actiontype, backup, fn)
    }
    // m端
    plat = native.in('wechat') ? 'wechat' : 'h5'
    // 如果是微信，还要区分小程序和微信浏览器
    if (plat === 'wechat') {
      isGetPlating = true
      legicCacheList.push({ actiontype, backup, fn })
      // 使用 native.asyncIn，同一个埋点会发多次，所以暂时使用这种方法
      native.asyncIn(
        'wa',
        () => {
          plat = 'wa'
          manageLegicCacheList()
        },
        () => {
          plat = 'wechat'
          manageLegicCacheList()
        }
      )
    } else {
      legic(actiontype, backup, fn)
    }
  }
}

function manageLegicCacheList() {
  isGetPlating = false
  legicCacheList.forEach(({ actiontype, backup, fn }) => {
    legic(actiontype, backup, fn)
  })
  // 置为 []，防止被 native.asyncIn 二次调用
  legicCacheList = []
}

export { initLegoData, legic }
